import { Auth } from 'aws-amplify';
import toast from 'react-hot-toast';
import config from '../config';

const API_ENDPOINT = config.apiEndpoint;

// idToken, NOT accessToken — API Gateway COGNITO_USER_POOLS validates
// idTokens only (see shared-docs/error-surfacing.md).
async function getAuthHeaders() {
  try {
    const session = await Auth.currentSession();
    return { Authorization: session.getIdToken().getJwtToken() };
  } catch {
    return {};
  }
}

async function request(path, method = 'GET', body = null) {
  const authHeaders = await getAuthHeaders();
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders,
    },
  };
  if (body) options.body = JSON.stringify(body);

  const res = await fetch(`${API_ENDPOINT}${path}`, options);

  if (!res.ok) {
    if (res.status === 401) {
      window.location.href = '/login';
      return undefined;
    }
    const err = await res.json().catch(() => ({ error: res.statusText }));
    const message = err.error || err.message || `API error: ${res.status}`;
    toast.error(message);
    // Re-throw with the payload attached so call sites can branch on
    // structured codes (CADENCE_PRO_REQUIRED, CHAT_LIMIT, ...).
    const e = new Error(message);
    e.status = res.status;
    e.data = err;
    throw e;
  }

  return res.json();
}

export async function apiGet(path) {
  return request(path, 'GET');
}

export async function apiPost(path, body) {
  return request(path, 'POST', body);
}

export async function apiPut(path, body) {
  return request(path, 'PUT', body);
}

export async function apiDelete(path) {
  return request(path, 'DELETE');
}

// Silent fetch — for background operations that fire on every app launch
// (IAP receipt re-delivery, subscription status sync, health snapshot push).
// No toast, no throw — returns null on any failure.
export async function silentFetch(path, method = 'GET', body = null) {
  try {
    const authHeaders = await getAuthHeaders();
    const options = {
      method,
      headers: { 'Content-Type': 'application/json', ...authHeaders },
    };
    if (body) options.body = JSON.stringify(body);
    const res = await fetch(`${API_ENDPOINT}${path}`, options);
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}
